import React, { useState } from 'react';
import { func, object, string } from 'prop-types';
import { Input } from 'library/components/form-components';
import SelectableSortableList from 'library/components/selectable-sortable-list';
import withData from 'util/hoc/with-data';
import withUser from 'util/hoc/with-user';
import DataQuery from 'library/util/query';
import {
  StyledSelectableRow,
  StyledBodyText,
  StyledUnsortedRowDetail,
} from 'apps/journey/pages/professional-center/professional-outcomes/components/styled-selectable-row';
import { createProfessionalCenterGroup } from 'apps/journey/pages/professional-center/queries/user-groups';
import { CreateNewGroupRow, Button } from './styles';
import GroupRowItem from './group-row-item';
import { NotificationRender } from 'library/components/notification';
import ReloadParentContext from 'context/reload-parent-context';

const GroupsList = ({ graph_data, reload_graph, currentOrganization }) => {
  const results = graph_data?.professional_center_groups || [];
  const [newGroupName, setNewGroupName] = useState('');

  const handleChange = (e) => setNewGroupName(e?.target?.value);

  const createGroup = async () => {
    const { success } = await createProfessionalCenterGroup({
      orgId: currentOrganization,
      name: newGroupName,
    });
    if (success) {
      await reload_graph();
      NotificationRender(
        'success',
        'Your group has been successfully submitted'
      );
      setNewGroupName('');
    } else {
      NotificationRender('info', 'There was an error submitting your group');
    }
  };

  return (
    <ReloadParentContext.Provider value={reload_graph}>
      <CreateNewGroupRow>
        <Input
          label="Create New Group"
          name="create_new_group"
          type="text"
          value={newGroupName}
          onChange={handleChange}
          key="create_new_group"
        />
        <Button onClick={createGroup}>Add</Button>
      </CreateNewGroupRow>
      <StyledSelectableRow borderTop="none">
        <StyledUnsortedRowDetail>
          <StyledBodyText key="name" bold>
            Group Name
          </StyledBodyText>
          <StyledBodyText key="user_count" bold>
            Individuals in Group
          </StyledBodyText>
        </StyledUnsortedRowDetail>
      </StyledSelectableRow>
      <SelectableSortableList
        data={results}
        rowComponent={GroupRowItem}
        onSelect={() => console.log('on select')}
        type="Group"
        noSort
      />
    </ReloadParentContext.Provider>
  );
};

GroupsList.propTypes = {
  graph_data: object,
  searchQuery: string,
  handleSelection: func,
};

GroupsList.defaultProps = {
  graph_data: {},
};

GroupsList.query = (token, { searchQuery, limit = 25, offset, orderASC }) =>
  DataQuery(`
    {
      professional_center_groups {
        id
        name
        count:group_members_count
        organization {
          id
        }
      }
    }
`);

export default withUser(withData(GroupsList));
